import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from './mid_energy_inconsistent_icon.svg'

const MidEnergyInconsistentIcon: React.VFC<SvgIconProps> = props => <SvgIcon component={Icon} {...props} />
export default MidEnergyInconsistentIcon
